import axios from "axios";

export const reportUrl =
location.hostname === "ota.rayneo.cn" || location.hostname === "ota.rayneo.com"
  ? "https://dc-o.api.leiniao.com/frontreport/custom"
  : 'https://dc-t.api.leiniao.com/frontreport/custom';

const service = axios.create({
  timeout: 5000,
});
export default service;
